import React from 'react';

import {
  Navigate,
  useLocation,
} from 'react-router-dom';

const RequireAdmin = ({
  adminUser,
  adminAuthChecked,
  children,
}) => {
  const location =
    useLocation();

  if (!adminAuthChecked) {
    return (
      <main
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          background: '#f5f7f9',
          color: '#073b70',
        }}
      >
        Checking administrator session...
      </main>
    );
  }

  if (!adminUser) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{
          from:
            location.pathname +
            location.search,
        }}
      />
    );
  }

  return children;
};

export default RequireAdmin;
